import { jsx as _jsx } from "react/jsx-runtime";
import { Form as FormikForm } from "formik";
const Form = (props) => {
    let className = "standardform";
    if (props.className != null) {
        className = `${className} ${props.className}`;
    }
    return (_jsx(FormikForm, { noValidate: true, className: className, children: props.children }));
};
export default Form;
